import { Pipe, PipeTransform } from '@angular/core';

import { Utils } from '@shared/utils/utils';

@Pipe({
  name: 'clpCurrency',
  standalone: true,
})
export class ClpCurrencyPipe implements PipeTransform {
  private readonly utils = new Utils();

  transform(value: number | undefined | null, removeSymbol = false): string {
    return this.utils.formatCurrency(value, removeSymbol);
  }
}
